import { Component } from '@angular/core';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'qwiko-splash-loader',
  imports: [AlertComponent],
  templateUrl: './splash-loader.component.html',
  styleUrl: './splash-loader.component.scss',
})
export class SplashLoaderComponent {}
